import { useContext } from 'react';
import { useSelector } from 'react-redux';
import t from 'react-translate';

import MentoringProgramContext from 'athena/components/mentoring-program/context';
import useConnection from 'athena/hooks/use-connection';
import { getMentoringProgramGoalItems, getMentoringProgramGoals } from 'redux/selectors/mentorship-program-goal-items';
import { getMentoringProgramActionItems } from 'redux/selectors/mentorship-program-action-items';
import { ActionItemStatus, MentoringProgramActionItem } from 'redux/schemas/models/mentoring-program-action-items';
import ReflectionGoals from './reflection-goals';
import ReflectionActionItems from './reflection-action-items';

const ReflectionLookingBack = () => {
  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { mentorshipProgramEnrollment: currentEnrollmentId } = mentoringProgram || {};
  const { connection } = useConnection(currentEnrollmentId);
  const connectionId = connection?.connectionId;

  const goalItems = useSelector(getMentoringProgramGoalItems(connectionId));
  const goals = useSelector(getMentoringProgramGoals(connectionId));
  const allActionItems = useSelector(getMentoringProgramActionItems(connectionId));

  const hasGoals = goals.length > 0;
  const hasCompletedActionItems = allActionItems.some(
    (item: MentoringProgramActionItem) => item.status === ActionItemStatus.COMPLETED,
  );
  const showLookingBack = goalItems !== undefined && (hasGoals || hasCompletedActionItems);

  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.REFLECTION_WORKSPACE;

  return (
    <>
      {showLookingBack && (
        <div>
          <div className='heading-2 black mb-2'>{translationBase.LOOKING_BACK()}</div>
          <p className='heading-5 gray-1'>{translationBase.SUBTITLE()}</p>
        </div>
      )}
      <ReflectionGoals />
      <ReflectionActionItems />
    </>
  );
};

export default ReflectionLookingBack;
